import * as Yup from 'yup';

import { IFormData } from './interfaces';

export const formValidation = async (data: IFormData): Promise<void> => {
  const validationShape = Yup.object().shape({
    name: Yup.string().required('Preencha este campo!'),
    email: Yup.string()
      .email('Insira um email válido!')
      .required('Preencha este campo!'),
    birthdate: Yup.string()
      .min(10, 'Insira uma data válida!')
      .max(10, 'Insira uma data válida!')
      .required('Preencha este campo!'),
    cellphone: Yup.string().required('Preencha este campo!'),
    phone: Yup.string().required('Preencha este campo!'),
    zipcode: Yup.string().required('Preencha este campo!'),
    address: Yup.string().required('Preencha este campo!'),
    city: Yup.string().required('Preencha este campo!'),
    state: Yup.string().required('Preencha este campo!'),
    password: Yup.string().required('Preencha este campo!'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password')], 'As senhas não conferem!')
      .required('Preencha este campo!'),
    person_type: Yup.string().required('Preencha este campo!'),
    document: Yup.string().required('Preencha este campo!'),
  });

  await validationShape.validate(data, {
    abortEarly: false,
  });
};
